import Axios from 'axios';
import { getHeaders } from '../../utills';
import AlertAction from '../Actions/AlertActions';
import GeneralAction from '../Actions/GeneralAction';
import TimeSheetActions from '../Actions/TimeSheetActions';
import Apis from '../Apis';


class TimeSheetMiddleware {

  static getTimeSheetCleaner = (userData) => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading())
      return new Promise(async (resolve, reject) => {
        try {
          if (userData?.search || userData?.next_page_url == undefined) {
            if (userData?.search && userData?.next_page_url) {
            }
            else {
              dispatch(TimeSheetActions.clearTimeSheetCleaner())
            }
          }
          let formdata = new FormData()
          formdata.append('name', userData?.search);
          formdata.append('category_id', userData?.Status);
          const { data } = await Axios.post(
            Apis.cleaners(userData?.next_page_url),
            formdata,
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            dispatch(TimeSheetActions.getTimeSheetCleaner(data?.data))
            dispatch(GeneralAction.HideLoading())
          } else {
            dispatch(GeneralAction.HideLoading())
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          console.log(error);
          dispatch(GeneralAction.HideLoading())
        }
      });
    };
  }

  static getTimeSheetList = (userData) => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading())
      return new Promise(async (resolve, reject) => {
        try {
          if (userData?.location_id || userData?.date_from || userData?.date_to || userData?.next_page_url == undefined) {
            if (userData?.location_id && userData?.date_from && userData?.date_to && userData?.next_page_url) {
            }
            else {
              dispatch(TimeSheetActions.clearTimeSheet())
            }
          }
          let formdata = new FormData()
          formdata.append('cleaner_id', userData?.cleaner_id);
          formdata.append('location_id', userData?.location_id);
          formdata.append('date_from', userData?.date_from);
          formdata.append('date_to', userData?.date_to);
          const { data } = await Axios.post(
            Apis.timeSheet(userData?.next_page_url),
            formdata,
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            dispatch(TimeSheetActions.getTimeSheet(data?.data))
            dispatch(GeneralAction.HideLoading())
          } else {
            dispatch(GeneralAction.HideLoading())
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          console.log(error);
          dispatch(GeneralAction.HideLoading())
        }
      });
    };
  }

}

export default TimeSheetMiddleware;